import '../scss/article.scss';
import menuModule from "./modules/menu.js";
import tableOfContentModule from "./modules/tableOfContentModule.js";
import footerModule from "./modules/footerModule.js";
import rateAndShareModule from "./modules/rateAndShareModule.js";
import sendPulseFormModule from "./modules/sendPulseFormModule.js";
import scrollSidebarModule from "./modules/scrollSidebarModule.js";
import timersModule from "./modules/timersModule.js";
import terminDescModule from "./modules/terminDescModule.js";
import mobileTableWidthSync from "./modules/mobileTableWidthSync.js";

import priceCoinWidget from "./widgets/price-coin-widget.js";

const initLightbox = async () => {
    if (!document.querySelector('.lightbox')) {
        return;
    }

    const { default: baguetteBox } = await import('baguettebox.js');
    baguetteBox.run('.lightbox');
};

const shouldInitCompareFixedBtn = () => {
    if (document.querySelector('.compare-btn, [data-add-to-compare], .compare-wrapper')) {
        return true;
    }

    try {
        return Object.keys(window.localStorage).some((key) => key.startsWith('compare_'));
    } catch (error) {
        return false;
    }
};

const initCompareFixedBtn = async () => {
    if (!shouldInitCompareFixedBtn()) {
        return;
    }

    const { default: compareFixedBtn } = await import('./modules/compareFixedBtn.js');
    compareFixedBtn.init();
};

const initDeferredModules = async () => {
    const [
        { default: faqModule },
        { default: commentsModule },
        { default: scrollUpModule },
        { default: reviewsModule },
        { default: shareModule },
    ] = await Promise.all([
        import('./modules/faqModule.js'),
        import('./modules/commentsModule.js'),
        import('./modules/scrollUpModule.js'),
        import('./modules/reviewsModule.js'),
        import('./modules/shareModule.js'),
    ]);

    faqModule.init();
    commentsModule.init();
    scrollUpModule.init();
    reviewsModule.init();
    shareModule.init();
};

const runWhenIdleOrLoaded = (callback) => {
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 1500 });
        return;
    }

    if (document.readyState === 'complete') {
        setTimeout(callback, 0);
        return;
    }

    window.addEventListener('load', () => {
        setTimeout(callback, 0);
    }, { once: true });
};

(function ($) {
    $(document).ready(function () {
        window.$ = jQuery;

        menuModule.init();
        tableOfContentModule.init();
        footerModule.init();
        priceCoinWidget.init();
        rateAndShareModule.init();
        sendPulseFormModule.init();
        scrollSidebarModule.init();
        timersModule.init();
        terminDescModule.init();
        mobileTableWidthSync.init();

        runWhenIdleOrLoaded(initDeferredModules);
        runWhenIdleOrLoaded(initCompareFixedBtn);
        runWhenIdleOrLoaded(initLightbox);

        $(document).on('click', '[data-show-rating-widget-info]', function (e) {
            e.preventDefault();
            $(e.target).closest('.widget-exchange-info-2__reverse').toggleClass('show');
        })

        $('[data-disclaimer-btn]').click(e => {
            e.preventDefault();
            $(e.target).closest('.disclaimer').toggleClass('disclaimer-open');
        });

        $('[data-hidden-rows-btn]').click(e => {
            e.preventDefault();
            $(e.target).closest('.hidden-rows').toggleClass('hidden-rows-open');
        });


        // Добавляем таблицам отзывчивости
        const tables = $('table');

        tables.each(function (tableIndex, table) {
            if(!$(table).closest('.table-responsive').length) {
                $(table).wrap('<div class="table-responsive"></div>')
            }
        })

        const syncTableScrollX = () => {
            const isMobile = window.innerWidth < 768;

            $('.table-responsive').each(function () {
                const $wrapper = $(this);
                const $scrollX = $wrapper.children('.table-responsive__scroll-x');
                const $table = $wrapper.children('table, .table_style');

                if (isMobile) {
                    if (!$scrollX.length && $table.length) {
                        $table.wrapAll('<div class="table-responsive__scroll-x"></div>');
                    }

                    const scrollXEl = $wrapper.children('.table-responsive__scroll-x')[0];
                    $wrapper.toggleClass('table-responsive--has-scroll-x', !!scrollXEl && scrollXEl.scrollWidth > scrollXEl.clientWidth + 1);
                } else {
                    if ($scrollX.length) {
                        $scrollX.children().unwrap();
                    }

                    $wrapper.removeClass('table-responsive--has-scroll-x');
                }
            });
        };

        syncTableScrollX();
        $(window).on('resize', syncTableScrollX);

        $(document).scroll(function () {
            $('div + h2').each(function (i, el) {
                const targetDiv = $(el).prev('div')[0];
                const scroll = targetDiv.getBoundingClientRect().y

                if(scroll > -50 && scroll < 50){
                    $('.sidebar-titles__list-item').removeClass('current')
                    const a = $(`.sidebar-titles__list-item a[href="#${targetDiv.id}"]`)[0];

                    if(a) {
                        $(a).parent().addClass('current')
                    }
                }
            })
        })


        // догружаем стили от expert review плагина. Отключили в actions
        // window.addEventListener('load', function() {
        //     let link = document.createElement('link');
        //     link.rel = 'stylesheet';
        //     link.href = '/wp-content/plugins/expert-review/assets/public/css/styles.min.css';
        //     document.head.appendChild(link);
        // });
    });
}(jQuery));
